import { FinancialSituationMonthlyExpenses } from '../../../../types';
export var list = [
    FinancialSituationMonthlyExpenses.BETWEEN_1K_AND_2K,
    FinancialSituationMonthlyExpenses.BETWEEN_2K_AND_5K,
    FinancialSituationMonthlyExpenses.BETWEEN_5K_AND_8K,
    FinancialSituationMonthlyExpenses.ABOVE_8K,
];
